import React from 'react';
import { Info } from 'lucide-react';
import { Card } from './ui/card';

/**
 * Composant affichant les conditions de séjour d'une villa
 * (jour d'arrivée obligatoire, séjour minimum, etc.)
 */
const StayConditions = ({ switchoverDay, minStay, maxGuests }) => {
  // Traduction des jours en français
  const dayTranslations = {
    'monday': 'Lundi',
    'tuesday': 'Mardi',
    'wednesday': 'Mercredi',
    'thursday': 'Jeudi',
    'friday': 'Vendredi',
    'saturday': 'Samedi',
    'sunday': 'Dimanche',
    '': 'Flexible'
  };

  const getDayInFrench = (day) => {
    if (!day || day === '') return 'Flexible';
    return dayTranslations[day.toLowerCase()] || day;
  };

  const hasConditions = switchoverDay || minStay;

  if (!hasConditions) return null;

  return (
    <Card className="p-4 bg-gradient-to-br from-amber-50 to-orange-50 border-amber-200">
      {/* Message d'information simplifié */}
      {switchoverDay && switchoverDay !== '' && minStay && (
        <div className="p-3 bg-white/60 rounded-lg border border-amber-200">
          <p className="text-sm text-gray-700 flex items-start gap-2">
            <Info className="w-4 h-4 text-amber-600 mt-0.5 flex-shrink-0" />
            <span>
              Pour cette villa, les réservations sont possibles <strong>du {getDayInFrench(switchoverDay)} au {getDayInFrench(switchoverDay)}</strong> avec un séjour minimum de <strong>{minStay} nuit{minStay > 1 ? 's' : ''}</strong>.
            </span>
          </p>
        </div>
      )}
    </Card>
  );
};

export default StayConditions;

